module.exports = __webpack_public_path__ + "media/new/ready-icon-big-a3cffef3.svg";